import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';

export function useAnalyticsStats(dateRange: { dateFrom?: string; dateTo?: string }) {
  return useQuery({
    queryKey: queryKeys.analytics.stats(dateRange),
    queryFn: () => analyticsApi.getStats(dateRange),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
